<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="notificationCategoryModal" aria-labelledby="notificationCategoryModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ category.id ? 'Категория: ' + (category.code || '') : 'Новая категория' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-9">
              <input-field v-model="category.code" :required="true" id="category.code" name="category.code" placeholder="Код" type="text" mb="5" />
            </div>
            <div class="col-md-3">
              <input-field v-model="category.sort" id="category.sort" name="category.sort" placeholder="Сортировка" type="number" mb="5" />
            </div>
          </div>
          
          <input-field v-model="category.icon" id="category.icon" name="category.icon" placeholder="Иконка" type="text" mb="5" />

          <div class="fs-6 fw-bold mb-3">Название (name)</div>
          <div class="row">
            <div class="col-md-4">
              <input-field v-model="category.name['ru-RU']" id="category.name.ru" name="category.name.ru" placeholder="Русский (ru-RU)" type="text" mb="5" />
            </div>
            <div class="col-md-4">
              <input-field v-model="category.name['uz-UZ']" id="category.name.uz" name="category.name.uz" placeholder="Узбекский (uz-UZ)" type="text" mb="5" />
            </div>
            <div class="col-md-4">
              <input-field v-model="category.name['en-US']" id="category.name.en" name="category.name.en" placeholder="Английский (en-US)" type="text" mb="5" />
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button type="button" @click="saveCategory" :disabled="saving" class="btn btn-primary btn-sm">
            {{ saving ? 'Сохранение...' : (category.id ? 'Обновить' : 'Создать') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const createLocaleObject = () => ({
  'ru-RU': '',
  'uz-UZ': '',
  'en-US': '',
});

const createDefaultCategory = () => ({
  id: null,
  code: '',
  icon: '',
  name: createLocaleObject(),
  sort: 0,
});

export default {
  name: 'NotificationCategoryModal',
  components: { Loader, InputField },
  props: {
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      category: createDefaultCategory(),
    };
  },
  mounted() {
    this.hydrateCategory();
    setTimeout(() => {
      const modalEl = document.getElementById('notificationCategoryModal');
      if (modalEl) {
        modalEl.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal(false);
        });
      }
    }, 10);
  },
  methods: {
    hydrateCategory() {
      const source = this.itemData || {};
      this.category = {
        ...createDefaultCategory(),
        ...source,
        name: { ...createLocaleObject(), ...(source.name || {}) },
      };
    },
    closeModal(isUpdate) {
      const modalInstance = bootstrap.Modal.getInstance(document.getElementById('notificationCategoryModal'));
      if (modalInstance) modalInstance.hide();
      this.$emit('closeModal', isUpdate);
    },
    saveCategory() {
      this.saving = true;
      const payload = {
        id: this.category.id || null,
        code: this.category.code || null,
        icon: this.category.icon || null,
        name: this.category.name,
        sort: Number(this.category.sort || 0),
      };

      axios.post('/notification/api/v2/issuer/category', payload)
        .then(() => {
          notify({
            duration: 7000,
            type: 'success',
            speed: 1000,
            title: 'Успешно',
            text: this.category.id ? 'Категория успешно обновлена!' : 'Категория успешно создана!',
          });
          this.closeModal(true);
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>

</style>
